import { BaseModel } from '../base.model';

export class SubLocation extends BaseModel {
  sublocationId: number;
  sublocationName: string;
  companyId: number;
  location: string;
  orderId?: number;
}
